<div [style.height]="height" [style.width]="width" [style.background]="background" [ngClass]="clazz"><ng-content></ng-content></div>